import React from "react"
import { Link } from "react-router-dom"
export default function PenaltyActions({ penalty, eventId, competitionId, onAction, returnTo }) {
  const editable = penalty.status !== "DELETED"
  return <div className="penalty-actions">
    <Link className="btn btn-light btn-sm" to={`/events/${eventId}/competitions/${competitionId}/${penalty._id}/add-penalties${returnTo ? "?returnTo=" + encodeURIComponent(returnTo) : ""}`}>{editable ? "Edit" : "View"}</Link>
    {editable && <>
      <button type="button" className="btn btn-light btn-sm" onClick={() => onAction(penalty.status === "DISABLED" ? "reactivate" : "deactivate")}>{penalty.status === "DISABLED" ? "Reactivate" : "Deactivate"}</button>
      <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => onAction("cancel")}>Cancel penalty</button>
    </>}
  </div>
}
